import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

const deliveryMatchMethod = {
  optionContentGap: css`var(--csc-delivery-match-method-option-content-gap, ${csSpacing.spacing05})`
}

export const hostStyle: CSSResult = css`
  .option {
    display: flex;
    gap: var(--csc-delivery-match-method-option-gap, ${csSpacing.spacing04});
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .option-content {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: ${deliveryMatchMethod.optionContentGap};
  }

  .option-inner {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: ${deliveryMatchMethod.optionContentGap};
    flex: 1;
  }

  .method-price-wrapper {
    --cse-text-text-align: right;
    --cs-font-body-line-height: 1;
    min-width: 75px;
    text-align: right;
  }

  .method-price {
    margin-left: auto;
    display: block;
    width: fit-content;
  }

  .method-name {
    font-weight: bold;
    flex: 1;
  }

  .carrier-image {
    min-width: max-content;
    height: 30px;
  }

  @media (min-width: ${SCREENS.small}) {
    .carrier-image {
      height: 40px;
    }
  }
`
